import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import FadeIn from '../components/FadeIn';

export default function CouplesRegion() {
  const regions = [
    {
      title: "Claremont & The Inland Empire",
      desc: "The premier private estate destination for the Inland Empire. Giving couples from Claremont, Rancho Cucamonga, Upland, and Ontario an elevated, luxury aesthetic without requiring their guests to travel to the coast.",
      hub: { name: "Explore the Inland Empire Guide", path: "/inland-empire-wedding-venue" },
      image: "https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_48_01%20PM.png"
    },
    {
      title: "Pasadena & San Gabriel Valley",
      desc: "Couples from Pasadena, San Marino, and Arcadia appreciate our authentic 1930s architecture, sophisticated dining experiences, and the exclusivity of a private estate setting that mirrors the historic charm of their own neighborhoods.",
      hub: { name: "Explore the Pasadena Guide", path: "/pasadena-wedding-venue" },
      image: "https://ik.imagekit.io/aeu02xvjgn/34-padua-hills-theatre-claremont-persian-wedding-photography.jpg"
    },
    {
      title: "Orange County",
      desc: "Couples from Newport Beach, Irvine, and Laguna Niguel trade crowded coastal resorts and master-planned country clubs for a deeply romantic, historic retreat with sweeping mountain views and unmatched privacy.",
      hub: { name: "Explore the Orange County Guide", path: "/orange-county-wedding-venue" },
      image: "https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Kelley-and-Faisal-56.jpg"
    },
    {
      title: "Los Angeles & The Valleys",
      desc: "Couples from Glendale, Burbank, and Los Feliz escape the industry hustle, traffic, and city noise ordinances for an editorial, cinematic backdrop where the entire property is exclusively theirs for the day.",
      hub: { name: "Explore the Los Angeles Guide", path: "/los-angeles-wedding-venue" },
      image: "https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_30_31%20PM.png"
    }
  ];

  return (
    <main className="bg-brand-vintage pb-0">
      <SeoMeta 
        title="Where Our Couples Come From | Padua Weddings Regions" 
        description="Discover why affluent couples from the Inland Empire, Pasadena, Orange County, and Los Angeles choose Padua as their destination-worthy private estate wedding venue." 
      />
      
      <PageHero 
        title="Where Our Couples Come From" 
        subtitle="A sophisticated, private estate destination drawing couples from across Southern California's finest neighborhoods."
        image="https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_30_31%20PM.png"
      />

      <section className="py-24 px-6 max-w-5xl mx-auto">
        <FadeIn className="text-center mb-20">
          <h2 className="font-serif text-3xl md:text-5xl text-brand-charcoal mb-8 font-light">
            A Destination-Worthy Estate
          </h2>
          <p className="font-sans text-brand-charcoal/80 text-lg leading-relaxed font-light max-w-3xl mx-auto">
            Padua is not defined by proximity, but by the experience it offers. Couples from highly sought-after neighborhoods across Southern California purposefully bypass standard luxury hotels and country clubs to host their celebration at our historic, secluded estate. We have consolidated our regional guides to help you understand why couples travel to us.
          </p>
        </FadeIn>

        <div className="space-y-16">
          {regions.map((region, idx) => (
            <FadeIn key={idx} delay={idx * 0.1} className="bg-white shadow-sm border border-brand-stone/20 overflow-hidden flex flex-col md:flex-row">
              <div className="w-full md:w-2/5 aspect-[4/3] md:aspect-auto">
                <img src={region.image} alt={region.title} className="w-full h-full object-cover" />
              </div>
              <div className="w-full md:w-3/5 p-10 md:p-14 flex flex-col justify-center">
                <h3 className="font-serif text-2xl md:text-3xl text-brand-charcoal mb-4">{region.title}</h3>
                <p className="font-sans text-brand-charcoal/70 font-light mb-8 text-base leading-relaxed">
                  {region.desc}
                </p>
                {region.hub && (
                  <Link 
                    to={region.hub.path} 
                    className="text-[10px] uppercase tracking-widest text-brand-olive border-b border-brand-olive pb-1 hover:text-brand-charcoal hover:border-brand-charcoal transition-colors w-max font-bold"
                  >
                    {region.hub.name}
                  </Link>
                )}
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      <CTASection />
    </main>
  );
}